
import { useEffect, useRef } from "react";
import {
  Layout,
} from "antd";
import "antd/dist/reset.css";

import AppRouter from "./Routes";

import { HeaderProvider, syncAllOfflineQueues, usePWA } from "@seims/shared";
import { TimerControl } from "@seims/shared/src/components/custom/TimerControl";
import { EventsHeader } from "../menu/Header/EventsHeader";
import { attemptTokenRefresh, subscribeToAuthErrors } from "@seims/shared/src/security";
import LookupSyncBanner from "src/common/components/LookupSyncBanner";

const { Header, Content } = Layout;

export const AuthorizedLayout = () => {
  const { isOnline } = usePWA();

  const prevOnlineRef = useRef(isOnline);
  
  // Handle token refresh on reconnect and sync queued data
  useEffect(() => {
    if (!prevOnlineRef.current && isOnline) {
      // App just came back online
      (async () => {
        console.log("[Reconnect] App is back online, attempting token refresh before queue sync...");
        
        const tokenValid = await attemptTokenRefresh();
        
        if (tokenValid) {
          console.log("[Reconnect] Token is valid, syncing queued data...");
          syncAllOfflineQueues().then((result) => {
            if (result.syncedCount > 0) {
              console.log(`[Sync] ${result.syncedCount} item(s) synced after reconnect`);
            }
            if (result.failedCount > 0) {
              console.warn(`[Sync] ${result.failedCount} item(s) failed to sync after reconnect`);
            }
          });
        } else {
          console.warn("[Reconnect] Token refresh failed, queued data will retry on next reconnect");
        }
      })();
    }
    prevOnlineRef.current = isOnline;
  }, [isOnline]);

  // Listen for auth errors from queued mutations
  useEffect(() => {
    const unsubscribe = subscribeToAuthErrors((event) => {
      const { detail } = event;
      if (detail?.type === "TOKEN_EXPIRED") {
        console.error("[Auth] Token expired during queue sync, will retry on reconnect");
        // Could trigger a toast or modal here to inform user
      }
    });

    return unsubscribe;
  }, []);

  return (
    <HeaderProvider>
      <Layout className="site-layout pwa-header" style={{ marginLeft: 200 }}>
        <Header>
          <EventsHeader />
        </Header>
        <Content style={{ margin: '0 16px' }}>
          {isOnline && <LookupSyncBanner />          }
          {isOnline && <TimerControl />}
          <AppRouter />
        </Content>
        {/* <Footer style={{ textAlign: 'center' }}>
          <FooterView />
        </Footer> */}
      </Layout>
    </HeaderProvider>
  );
};

export default AuthorizedLayout;